import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "mt-4" }

import MunicipalitySelect from "@/components/MunicipalitySelect.vue";
import CountrySelect from "@/components/CountrySelect.vue";
import LanguageSelect from "@/components/LanguageSelect.vue";
import LanguageSkillsField from "@/components/LanguageSkillsField.vue";
import RadioField from "@/components/RadioField.vue";
import { useValidateProps } from "@/composables/fields";
import { isMobileReactive } from "@/helpers";
import { dbEnums } from "@/types/enums/dbEnums";
import { SelectOption } from "@/types/interfaces/field";
import { DraftStartupperDto } from "@api/draft-startupper-dto";
import { PropType, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { PersonFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StartupperFormBasicFields',
  props: {
	fieldsMap: {
		type: Object as PropType<PersonFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftStartupperDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const { t } = useI18n();

const props = __props;

const fields = dbEnums.PersonFields;
const genderOptions = computed(
	() =>
		[
			{ text: t("genders.man"), value: dbEnums.Genders.Man },
			{ text: t("genders.woman"), value: dbEnums.Genders.Woman },
			{ text: t("genders.other"), value: dbEnums.Genders.Other },
			{ text: t("genders.unknown"), value: null },
		] as SelectOption[]
);

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!
  const _component_HakoDatePicker = _resolveComponent("HakoDatePicker")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("startupperForm.sectionHeaders.basicInfo")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.StartupperBasicInfo)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.StartupperBasicInfo.fields
            }, {
              [_unref(fields).StartupperFirstName]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.firstName"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.firstName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.firstName) = $event)),
                      id: elementId,
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).StartupperSecondNames]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.secondNames"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.secondNames,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.secondNames) = $event)),
                      id: elementId,
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).StartupperLastName]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.lastName"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.lastName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.lastName) = $event)),
                      id: elementId,
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).StartupperCommunicationLanguage]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.communicationLanguageId"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(LanguageSelect, {
                      valueSingle: formDataComputed.value.communicationLanguage,
                      "onUpdate:valueSingle": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.communicationLanguage) = $event)),
                      valueSingleId: formDataComputed.value.communicationLanguageId,
                      "onUpdate:valueSingleId": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.communicationLanguageId) = $event)),
                      communicationRole: _unref(dbEnums).PersonUserRoleIds.AlkavatYrittajat,
                      id: elementId,
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId", "communicationRole", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).StartupperIsElectronicCommunicationAllowed]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftStartupperData.isElectronicCommunicationAllowed"
                  }, {
                    default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                      _createVNode(_component_HakoCheckbox, {
                        modelValue: formDataComputed.value.isElectronicCommunicationAllowed,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed.value.isElectronicCommunicationAllowed) = $event)),
                        for: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("generic.yes")), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "for", "isInvalid", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).StartupperLanguageSkills]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "languageSkills"
                }, {
                  default: _withCtx(() => [
                    _createVNode(LanguageSkillsField, {
                      modelValue: formDataComputed.value.languageSkills,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.languageSkills) = $event)),
                      propertyPath: "draftStartupperData.languageSkills",
                      style: {"max-width":"750px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).StartupperTitle]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.title"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.title,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.title) = $event)),
                      id: elementId,
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).StartupperIsContactAdmitAllowed]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftStartupperData.isContactInfoAdmitAllowed"
                  }, {
                    default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                      _createVNode(_component_HakoCheckbox, {
                        modelValue: formDataComputed.value.isContactInfoAdmitAllowed,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formDataComputed.value.isContactInfoAdmitAllowed) = $event)),
                        for: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("generic.dataDisclosureToThirdParty")), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "for", "isInvalid", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).StartupperDateOfBirth]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.birthday"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoDatePicker, {
                      modelValue: formDataComputed.value.birthday,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formDataComputed.value.birthday) = $event)),
                      allowEmpty: "",
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"250px"},
                      placeholder: _ctx.$t('generic.datePlaceholder'),
                      forceUtcMidnight: ""
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).StartupperGender]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.genderId"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(RadioField, {
                      modelValue: formDataComputed.value.genderId,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formDataComputed.value.genderId) = $event)),
                      inline: !_unref(isMobileReactive),
                      options: genderOptions.value,
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "inline", "options", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).StartupperCountryOfBirth]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftStartupperData.countryOfBirth"
                  }, {
                    default: _withCtx(({ elementId }) => [
                      _createVNode(CountrySelect, {
                        valueSingleId: formDataComputed.value.countryOfBirthId,
                        "onUpdate:valueSingleId": _cache[11] || (_cache[11] = ($event: any) => ((formDataComputed.value.countryOfBirthId) = $event)),
                        valueSingle: formDataComputed.value.countryOfBirth,
                        "onUpdate:valueSingle": _cache[12] || (_cache[12] = ($event: any) => ((formDataComputed.value.countryOfBirth) = $event)),
                        ajax: true,
                        id: elementId,
                        lowercase: "",
                        style: {"max-width":"500px"}
                      }, null, 8, ["valueSingleId", "valueSingle", "id"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).StartupperNationality]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftStartupperData.nationality"
                  }, {
                    default: _withCtx(({ elementId }) => [
                      _createVNode(CountrySelect, {
                        valueSingle: formDataComputed.value.nationality,
                        "onUpdate:valueSingle": _cache[13] || (_cache[13] = ($event: any) => ((formDataComputed.value.nationality) = $event)),
                        valueSingleId: formDataComputed.value.nationalityId,
                        "onUpdate:valueSingleId": _cache[14] || (_cache[14] = ($event: any) => ((formDataComputed.value.nationalityId) = $event)),
                        ajax: true,
                        id: elementId,
                        lowercase: "",
                        isCitizenship: "",
                        style: {"max-width":"500px"}
                      }, null, 8, ["valueSingle", "valueSingleId", "id"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).StartupperHomeMunicipality]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftStartupperData.homeMunicipalityId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(MunicipalitySelect, {
                      valueSingle: formDataComputed.value.homeMunicipality,
                      "onUpdate:valueSingle": _cache[15] || (_cache[15] = ($event: any) => ((formDataComputed.value.homeMunicipality) = $event)),
                      valueSingleId: formDataComputed.value.homeMunicipalityId,
                      "onUpdate:valueSingleId": _cache[16] || (_cache[16] = ($event: any) => ((formDataComputed.value.homeMunicipalityId) = $event)),
                      ajax: "",
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})